module.exports = __webpack_public_path__ + "static/img/tv-asahi_archive_logo.9ab100b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/works/video-archive/tv-asahi_archive_logo.png
// module id = N2OA
// module chunks = 0